// extracted by mini-css-extract-plugin
export default {"wrapper":"onboarding_wrapper__AaSus","container":"onboarding_container__Vnx6D","formWrapper":"onboarding_formWrapper__6vZMP","logo":"onboarding_logo__8K+1p"};